import React from 'react';
// JobSeekerHero import kept for potential future use
// import { JobSeekerHero } from './JobSeekerHero';
import { RecruiterHero } from './RecruiterHero';

export type AudienceType = 'jobseeker' | 'recruiter';

interface LandingPageProps {
  activeAudience?: AudienceType;
}

export const LandingPage: React.FC<LandingPageProps> = () => {
  return (
    <section className="relative w-full min-h-screen bg-white flex flex-col">
      {/* Professional Background - White to Blue Gradient with Texture */}
      <div className="absolute inset-0 z-0 pointer-events-none select-none">
        {/* Base White Background */}
        <div className="absolute inset-0 bg-white" />

        {/* Subtle Vertical Gradient (White -> Very Light Blue) */}
        {/* Starts white, fades to a soft blue near bottom to ground the darker footer */}
        <div className="absolute inset-0 bg-gradient-to-b from-white via-white to-blue-50/50" />

        {/* Abstract "Hero Glow" - Central light source */}
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] opacity-60"
          style={{
            background: 'radial-gradient(circle at 50% 0%, rgba(219, 234, 254, 0.4) 0%, transparent 60%)',
            filter: 'blur(60px)',
          }}
        />

        {/* Professional Dot Texture Pattern */}
        <div
          className="absolute inset-0 opacity-[0.4]"
          style={{
            backgroundImage: `radial-gradient(#94a3b8 1px, transparent 1px)`,
            backgroundSize: '32px 32px',
            maskImage: 'linear-gradient(to bottom, transparent, black 20%, black 80%, transparent)'
          }}
        />
      </div>

      {/* Content Container - Uses flexbox for vertical centering */}
      <div className="relative z-10 flex-1 flex flex-col pt-16 md:pt-20 min-h-[calc(100vh-80px)]">
        <div className="flex-1 flex flex-col">
          <RecruiterHero />
        </div>
      </div>
    </section>
  );
};
